<ng-container  *ngIf="isSupportedBreakPoint else unSupportedView">
    <router-outlet></router-outlet>
</ng-container>
<ng-template #unSupportedView>
  <div class="page-selector unsupported-msg">
    <div class="page-inner">
      <div class="body-cont">
        <p *ngIf="isDesktop" class="paragraph-lg-c-bold">Please expand the width of your browser for a better accessibility experience.</p>
        <p *ngIf="!isDesktop" class="paragraph-lg-c-bold">It is a web application, please open it on a laptop or desktop only.</p>
      </div>
    </div>
  </div>
</ng-template>

